import React, { useState } from "react";
import image from "../image.png";
import cx from "classnames";

type Props = {
  className?: string;
  progressClassName?: string;
};

const Task: React.FC<Props> = ({
  className = "",
  progressClassName = "w-4/12"
}) => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <div
      className={cx(
        `flex rounded-xl w-full py-4 px-3 bg-gray-50
         bg-opacity-20 hover:bg-opacity-30 transition-colors 
         duration-300 relative cursor-pointer`,
        className
      )}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {isHovering && (
        <div
          style={{
            bottom: "calc(100% + 5px)",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 2
          }}
          className="fadeIn absolute l-0 p-5 rounded-xl bg-white bg-gradient-to-b from-blue-800 to-indigo-800 text-gray-50"
        >
          <div style={{ minWidth: 300 }} className="p-3">
            <div className="flex text-green-500 font-bold">
              <div className="flex-grow">Tracked</div>
              <div>15h 30m</div>
            </div>
            <div className="flex ">
              <div className="flex-grow">Remaining</div>
              <div>3h 30m</div>
            </div>
            <div className="flex ">
              <div className="flex-grow">First estimation</div>
              <div>20h 30m</div>
            </div>
            <div className="flex ">
              <div className="flex-grow">Estimation now</div>
              <div>19h 00m</div>
            </div>
            <div className="mt-5">
              <h3 className="text-xl font-semibold">Labels</h3>
              <div className="pt-2">
                <span className="bg-red-500 text-white py-2 px-10 rounded-full">
                  Bug
                </span>
                <span className="bg-green-500 text-white py-2 px-10 rounded-full ml-2">
                  Feature X
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        style={{
          zIndex: 1,
          background:
            "linear-gradient(270deg, rgba(3, 255, 43, 0.25) 0%, rgba(3, 255, 43, 0.01) 100%)"
        }}
        className={
          "absolute h-full top-0 left-0 rounded-r-xl " + progressClassName
        }
      />
      <div className="flex items-center flex-grow" style={{ zIndex: 2 }}>
        <img src={image} className="m-0 mr-5" />
        <div className="text-gray-50 text-lg">This is task</div>
      </div>

      <svg
        style={{ zIndex: 2 }}
        className="text-gray-100 cursor-pointer"
        fill="currentColor"
        width="28"
        height="28"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M0 0h24v24H0z"
          fill="none"
        ></path>
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        ></path>
      </svg>
    </div>
  );
};

export default Task;
